import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';
import { Crosshair, CircleArrowUp, Contact, HelpCircle, UserCircle, Moon, Sun, Banknote, ArrowUp, LogOut, MoreHorizontal, X, LayoutGrid, MapPin, ChevronRight, MessageCircle, ExternalLink, MessageSquareText, Send, Menu, Rocket, TrendingUp, Package } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/axios';
import { motion, AnimatePresence } from 'framer-motion';

export default function PublicLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const isCotizarPage = location.pathname === '/cotizar';
  const isPuntoEntregaPage = location.pathname === '/punto-entrega';
  const [branches, setBranches] = useState([]);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isBranchModalOpen, setIsBranchModalOpen] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [chatStep, setChatStep] = useState('inicio');
  const [isAtFooter, setIsAtFooter] = useState(false);
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const [activeTour, setActiveTourState] = useState(() => {
    return sessionStorage.getItem('tbt_active_tour') || null;
  });
  const [isTourWADropdownOpen, setIsTourWADropdownOpen] = useState(false);

  const setActiveTour = (val) => {
    if (val) {
      sessionStorage.setItem('tbt_active_tour', val);
    } else {
      sessionStorage.removeItem('tbt_active_tour');
    }
    setActiveTourState(val);
  };

  const closeTour = () => {
    setActiveTour(null);
    setIsSidebarOpen(false);
  };

  const handleStartSucursalesTour = () => {
    setIsChatOpen(false);
    setActiveTour('sucursales');
    if (location.pathname !== '/') {
      navigate('/#sucursales');
    } else {
      const element = document.getElementById('sucursales');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  useEffect(() => {
    if (activeTour === 'rastreo' && location.pathname !== '/' && window.innerWidth < 1024) {
      setIsSidebarOpen(true);
    }
  }, [activeTour, location.pathname]);

  useEffect(() => {
    const handleCloseTour = () => closeTour();
    window.addEventListener('tbt-close-tour', handleCloseTour);
    return () => window.removeEventListener('tbt-close-tour', handleCloseTour);
  }, []);

  useEffect(() => {
    // 1. Detección por eventos de Focus/Blur en inputs y textareas
    const handleFocusIn = (e) => {
      const tagName = e.target.tagName;
      if (tagName === 'INPUT' || tagName === 'TEXTAREA') {
        setIsKeyboardOpen(true);
      }
    };
    
    const handleFocusOut = (e) => {
      const tagName = e.target.tagName;
      if (tagName === 'INPUT' || tagName === 'TEXTAREA') {
        setIsKeyboardOpen(false);
      }
    };

    document.addEventListener('focusin', handleFocusIn);
    document.addEventListener('focusout', handleFocusOut);

    // 2. Detección por redimensionamiento del visualViewport (más exacto en móviles)
    const handleViewportResize = () => {
      if (window.visualViewport) {
        const isKeyboard = window.visualViewport.height < window.innerHeight * 0.85;
        setIsKeyboardOpen(isKeyboard);
      }
    };

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleViewportResize);
    }

    return () => {
      document.removeEventListener('focusin', handleFocusIn);
      document.removeEventListener('focusout', handleFocusOut);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleViewportResize);
      }
    };
  }, []);

  const branchLocations = {
    pachuca: {
      name: "Sucursal Pachuca (Mineral de la Reforma)",
      lat: 20.066689050729195,
      lng: -98.74314409140342,
      address: "3784+HPV Avenida A, Parque Industrial CANACINTRA 27-B, 42186 Parque Industrial La Reforma, Hgo."
    },
    toluca: {
      name: "Sucursal Toluca",
      lat: 19.2934821470003,
      lng: -99.55744502263089,
      address: "8C7Q+25V, Manzana 016, Reforma, 52120 San Pedro Totoltepec, Méx."
    }
  };
  // 1. Estado inicial buscando en localStorage
  const [isDark, setIsDark] = useState(
    localStorage.getItem('theme') === 'dark'
  );

  // 2. Efecto para aplicar la clase al HTML
  useEffect(() => {
    const root = window.document.documentElement;
    if (isDark) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }

  }, [isDark]);

  // Evita el scroll del fondo (body) cuando el menú lateral está abierto en celular
  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isSidebarOpen]);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('footer');
      if (!footer) return;

      const footerTop = footer.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      // Si el inicio del footer entra en pantalla, activamos el tope
      if (footerTop < windowHeight) {
        setIsAtFooter(true);
      } else {
        setIsAtFooter(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const { openAuthModal, logout, user, setAuthView } = useAuth();
  const isAuthenticated = !!user;
  // --- INICIO LÓGICA FOOTER DINÁMICO ---
  const [branchInfo, setBranchInfo] = useState({
    city: 'Cargando...',
    phone: 'Cargando...',
    email_contacto: 'Cargando...',
    direccion: 'Cargando...'
  });



  // La función getWhatsAppLink ahora tiene acceso a 'branches' y 'branchInfo'
  const getWhatsAppLink = (message) => {
    const safeBranches = Array.isArray(branches) ? branches : [];
    const target = branchInfo || safeBranches.find(b => b && (b.is_main == 1 || b.is_main === true)) || safeBranches[0];

    if (target?.phone) {
      const phone = target.phone.replace(/\D/g, '');
      return `https://wa.me/52${phone}?text=${encodeURIComponent(message)}`;
    }

    return "https://wa.me/527713466052";
  };
  useEffect(() => {
    const initLayout = async () => {
      try {
        // 1. Una sola petición al backend
        const res = await api.get('/branches');
        const rawBranches = res.data?.data || res.data;
        const allBranches = Array.isArray(rawBranches) ? rawBranches : [];

        if (allBranches.length === 0) return;

        // 2. Actualizamos ambos estados de una vez
        setBranches(allBranches);

        // 3. Lógica de ubicación (Geolocalización)
        let ciudadUsuario = '';
        try {
          const ipRes = await fetch('https://ipwho.is/');
          const ipData = await ipRes.json();
          ciudadUsuario = ipData.city?.toLowerCase() || '';
        } catch (e) {
          console.warn("Geolocalización desactivada o bloqueada");
        }

        // 4. Búsqueda inteligente
        const matched = allBranches.find(b =>
          (b && b.city && ciudadUsuario.includes(b.city.toLowerCase()))
        );

        const principal = allBranches.find(b => b && (b.is_main == 1 || b.is_main === true)) || allBranches[0];
        if (matched || principal) {
          setBranchInfo(matched || principal);
        }

      } catch (error) {
        console.error("Error inicialización del layout (usando respaldo seguro):", error);
      }
    };

    initLayout();
  }, []);
  return (
    <div className="min-h-screen flex flex-col font-sans bg-transparent dark:bg-transparent dark:text-gray-100 transition-colors duration-500 public-layout-scale" style={{ fontFamily: "'Secular One', sans-serif" }}>
      {/* 1. SVG MASK (Definición invisible) */}
      <svg width="0" height="0" className="absolute">
        <defs>
          {/* La forma original de tu barra */}
          <clipPath id="header-shape" clipPathUnits="objectBoundingBox">
            <path d="M 0,0 L 0.98,0 L 1,0.58 L 0.98,1 L 0,1 Z" />
          </clipPath>

          {/* NUEVA FORMA PARA EL BOTÓN (Espejo invertido/inclinado) */}
          <clipPath id="header-shape-button" clipPathUnits="objectBoundingBox">
            <path d="M 0.15,0 L 1,0 L 1,1 L 0,1 Z" />
          </clipPath>
        </defs>
      </svg>

      {/* 2. CAPA DE FONDO FIJA OPTIMIZADA CON COBERTURA COMPLETA */}
      <div 
        className="fixed inset-0 w-full min-h-screen z-0 pointer-events-none select-none bg-cover bg-center bg-no-repeat opacity-95"
        style={{ backgroundImage: "url('/fondo.jpg')", height: '200vh', width: '200vw', minHeight: '150vh' }}
      >
        <div className="absolute inset-0 bg-black/75 pointer-events-none"></div>
        <div
          className="absolute inset-0 opacity-60 pointer-events-none"
          style={{ background: 'radial-gradient(circle at center 120%, #CE010B 0%, transparent 70%)' }}
        ></div>
      </div>

      {/* PESTAÑA LATERAL: PUNTO DE ENTREGA (Izquierda en móvil, derecha en desktop) */}
      {!isPuntoEntregaPage && (
        <div
          onClick={() => {
            closeTour();
            navigate('/punto-entrega');
          }}
          className="fixed left-0 lg:left-auto lg:right-0 top-[25%] lg:top-[36%] -translate-y-1/2 z-40 bg-gradient-to-br from-[#FF3333] to-[#D30000] dark:from-neutral-800 dark:to-black border-y-[3px] border-r-[3px] border-black dark:border-white lg:border lg:border-r-0 lg:border-l lg:border-black/10 lg:dark:border-white/20 text-white flex flex-col lg:flex-row items-center gap-2 lg:gap-3 py-8 lg:py-5 pr-4 lg:pr-5 pl-2 lg:pl-8 rounded-r-[2rem] rounded-l-none lg:rounded-l-[2.5rem] lg:rounded-r-none w-auto shadow-[0_15px_30px_rgba(0,0,0,0.6)] lg:shadow-[0_10px_25px_rgba(206,1,11,0.3)] cursor-pointer hover:scale-105 active:scale-95 transition-all duration-300 group select-none animate-in slide-in-from-left lg:slide-in-from-right duration-300"
        >
          <div className="bg-white/10 p-1 lg:p-2 rounded-full shrink-0 group-hover:scale-110 transition-transform flex items-center justify-center order-1 lg:order-1">
            <Package size={30} className="text-white lg:hidden" />
            <Package size={22} className="text-white hidden lg:block" />
          </div>
          {/* Mobile vertical letters stack */}
          <div className="flex flex-col lg:hidden items-center mt-3 font-black text-[24px] tracking-wider uppercase select-none leading-none gap-1">
            <span>P</span>
            <span>U</span>
            <span>N</span>
            <span>T</span>
            <span>O</span>
            <span className="my-1 text-[15px] opacity-75">DE</span>
            <span>E</span>
            <span>N</span>
            <span>T</span>
            <span>R</span>
            <span>E</span>
            <span>G</span>
            <span>A</span>
          </div>
          {/* Desktop horizontal text */}
          <div className="hidden lg:flex flex-col text-left leading-[1.0] font-black uppercase tracking-wider text-[14px] order-2 lg:order-2">
            <span>Punto</span>
            <span>de</span>
            <span>entrega</span>
          </div>
        </div>
      )}

      {/* LOGO FLOTANTE PARA MÓVIL (AUMENTADO 50%) */}
      <div className="fixed top-6 right-6 z-40 lg:hidden transition-all duration-300">
        <Link to="/" className="flex items-center bg-white/95 dark:bg-black/85 backdrop-blur-md border-[2px] border-black/10 dark:border-white/10 rounded-3xl px-6 py-3.5 shadow-lg active:scale-95 transition-transform">
          <img
            src={isDark ? "/LogoNuevoOscuro.png" : "/LogoNuevoClaro.png"}
            alt="Logo"
            className="h-12 w-auto object-contain"
          />
        </Link>
      </div>

      {/* PESTAÑA VERTICAL DE COTIZAR PARA MÓVIL (ARRIBA DEL MENÚ) */}
      {!isCotizarPage && (
        <div className={`fixed right-0 top-[25%] -translate-y-1/2 lg:hidden flex items-center justify-center transition-all duration-300 ${activeTour === 'cotizar' ? 'z-[90] scale-105' : 'z-50'}`}>
          <Link
            to="/cotizar"
            onClick={() => setActiveTour(null)}
            className="flex flex-col items-center justify-center bg-[#CE010B] dark:bg-gradient-to-b dark:from-[#590000] dark:to-[#780000] text-white border-y-[3px] border-l-[3px] border-black dark:border-white rounded-l-[2rem] py-9 pl-6 pr-3 shadow-[0_15px_30px_rgba(0,0,0,0.6)] cursor-pointer active:scale-95 transition-all"
            title="Cotizar envío"
          >
            <Banknote size={50} className="text-white animate-pulse" />
            <div className="flex flex-col items-center mt-3 font-black text-2xl tracking-wider uppercase select-none leading-none gap-1.5">
              <span>C</span>
              <span>O</span>
              <span>T</span>
              <span>I</span>
              <span>Z</span>
              <span>A</span>
              <span>R</span>
            </div>
          </Link>
          {activeTour === 'cotizar' && (
            <div className="absolute inset-0 border-[4px] border-[#CE010B] dark:border-[#FF3333] rounded-l-[2rem] shadow-[0_0_35px_rgba(206,1,11,0.8)] animate-pulse pointer-events-none" />
          )}
        </div>
      )}

      {/* PESTAÑA VERTICAL DE MENÚ PARA MÓVIL (CENTRADA VERTICALMENTE - COLOR BLANCO) */}
      <div
        onClick={() => setIsSidebarOpen(true)}
        className={`fixed right-0 top-[48%] -translate-y-1/2 lg:hidden flex flex-col items-center justify-center bg-white dark:bg-zinc-900 text-black dark:text-white border-y-[3px] border-l-[3px] border-black dark:border-white rounded-l-[2rem] py-8 pl-4 pr-2 shadow-[0_15px_30px_rgba(0,0,0,0.6)] cursor-pointer active:scale-95 transition-all
          ${activeTour === 'rastreo' && location.pathname !== '/'
            ? 'z-[90] border-y-[3px] border-l-[3px] !border-[#CE010B] dark:!border-[#FF3333] scale-105 ring-4 ring-[#CE010B] dark:ring-[#FF3333] shadow-[0_0_35px_rgba(206,1,11,0.8)] animate-pulse'
            : 'z-50'
          }`}
        title="Abrir menú"
      >
        <Menu size={42} className="text-black dark:text-white animate-pulse" />
        <div className="flex flex-col items-center mt-3 font-black text-2xl tracking-wider uppercase select-none leading-none gap-1.5">
          <span>M</span>
          <span>E</span>
          <span>N</span>
          <span>Ú</span>
        </div>
      </div>

      <header className={`fixed top-2 left-0 h-[76px] hidden lg:flex items-center transition-all duration-300 ${activeTour && (location.pathname !== '/' || activeTour === 'cotizar') ? 'z-[90]' : 'z-50'}`}>
        {/* CAPA 2: Actualizamos el gradiente para el modo oscuro */}
        <div
          className="absolute inset-0 bg-black p-[1.5px] -z-10"
          style={{ clipPath: 'url(#header-shape)' }}
        >
          <div
            /* Añadimos las clases dark: para el fondo oscuro del Navbar */
            className="h-full w-full transition-colors duration-500 bg-gradient-to-b from-white to-[#C1C1C1] dark:from-neutral-800 dark:to-neutral-950"
            style={{ clipPath: 'url(#header-shape)' }}
          />
        </div>

        {/* 3. CONTENEDOR DEL DISEÑO (Mantenemos tu altura de 76px) */}
        <div className="relative h-[76px] flex items-center"></div>

        {/* CAPA 1: GLOW NEGRO DISPERSADO (Ajustado a la nueva altura) */}
        <div
          className="absolute inset-0 bg-black opacity-25 filter blur-2xl -z-20"
          style={{ clipPath: 'url(#header-shape)' }}
        />

        {/* CAPA 2: BORDE FINO (1.5px) Y FONDO GRADIENTE */}
        <div
          // bg-black para el tema claro, dark:bg-white para el tema oscuro
          className="absolute inset-0 bg-black dark:bg-white p-[1.5px] -z-10 transition-colors duration-300"
          style={{ clipPath: 'url(#header-shape)' }}
        >
          <div
            className={`h-full w-full transition-all duration-500 
      bg-gradient-to-b from-white to-[#C1C1C1] 
      dark:from-tbt-red-top dark:to-tbt-red-bottom`}
            style={{ clipPath: 'url(#header-shape)' }}
          />
        </div>

        {/* CAPA 3: CONTENIDO (Gap-8 y Padding-12/20 para el look al 80%) */}
        <div className="flex items-center justify-between lg:justify-start gap-8 pl-6 pr-6 lg:pl-12 lg:pr-20 h-full w-full relative">

          <Link to="/" className="flex items-center flex-shrink-0 transition-transform hover:scale-105 mr-2">
            <img
              src={isDark ? "/LogoNuevoOscuro.png" : "/LogoNuevoClaro.png"}
              alt="Más Envíos Logo"
              className={`h-10 lg:h-11 w-auto object-contain transition-all duration-500`}
            />
          </Link>

          {/* BOTÓN HAMBURGUESA MÓVIL */}
          <button
            onClick={() => setIsSidebarOpen(true)}
            className={`lg:hidden flex items-center justify-center p-3.5 rounded-2xl text-black dark:text-white hover:bg-black/10 dark:hover:bg-white/15 active:scale-95 transition-all focus:outline-none border border-black/5 dark:border-white/10 shadow-sm
              ${activeTour === 'rastreo' && location.pathname !== '/'
                ? 'z-[90] border-[#CE010B] dark:border-[#FF3333] scale-105 ring-4 ring-[#CE010B] dark:ring-[#FF3333] shadow-[0_0_35px_rgba(206,1,11,0.8)] animate-pulse'
                : ''
              }`}
            title="Abrir menú"
          >
            <Menu size={32} />
          </button>

          <nav className="hidden lg:flex items-center gap-8 text-black h-full">



            {/* RASTREAR ENVÍO */}
            <Link
              to="/rastreo"
              onClick={() => setActiveTour(null)}
              className={`flex items-center gap-3 hover:text-[#CE010B] transition-colors group border-b border-black dark:border-white pb-1 mx-2 dark:text-white
                ${activeTour === 'rastreo' && location.pathname !== '/'
                  ? 'z-[90] scale-105 border-[#CE010B] dark:border-[#FF3333] ring-4 ring-[#CE010B] dark:ring-[#FF3333] shadow-[0_0_35px_rgba(206,1,11,0.8)] rounded-xl px-3 py-1.5 bg-white dark:bg-neutral-900 animate-pulse'
                  : ''
                }`}
            >
              <div className="flex flex-col leading-[1.1] text-[15px]">
                <span>Rastrear</span>
                <span>envío</span>
              </div>
              <Crosshair
                size={22}
                className="text-black dark:text-white group-hover:text-[#CE010B] transition-colors"
              />
            </Link>

            {/* MEJORA TU NEGOCIO */}
            <div className="relative group flex items-center h-full mx-2">
              {/* Disparador del menú */}
              <div className="flex items-center gap-3 cursor-pointer hover:text-[#CE010B] border-b border-black dark:border-white pb-1 transition-colors dark:text-white">
                <div className="flex flex-col leading-[1.1] text-[15px]">
                  <span>Mejora tu</span>
                  <span>negocio</span>
                </div>
                <CircleArrowUp size={22} className="transition-colors" />
              </div>

              {/* Ventana desplegable (Dropdown) */}
              <div className={`absolute top-[85%] left-0 w-56 border-[1.5px] rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-[100] translate-y-2 group-hover:translate-y-0
                bg-gradient-to-b from-white to-[#C1C1C1] border-black
                dark:from-tbt-red-top dark:to-tbt-red-bottom dark:border-white`}
              >
                <div className="flex flex-col text-center py-1">
                  <HashLink
                    scroll={(el) => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                    to="/#faq"
                    className="px-4 py-4 text-[15px] font-normal transition-colors text-black hover:bg-black/5 dark:text-white dark:hover:bg-white/10"
                  >
                    Empieza tu negocio
                  </HashLink>

                  {/* Separador visual */}
                  <div className="h-[1px] bg-black/20 dark:bg-white/20 mx-4"></div>

                  <HashLink
                    scroll={(el) => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                    to="/#empresa"
                    className="px-4 py-4 text-[15px] font-normal transition-colors text-black hover:bg-black/5 dark:text-white dark:hover:bg-white/10"
                  >
                    Mejora tu empresa
                  </HashLink>
                </div>
              </div>
            </div>

            {/* BOLSA DE TRABAJO */}
            <Link
              to="/trabajos"
              className="flex items-center gap-3 hover:text-[#CE010B] border-b border-black dark:border-white pb-1 mx-2 dark:text-white transition-colors duration-500"
            >
              <div className="flex flex-col leading-[1.1] text-[15px]">
                <span>Bolsa de</span>
                <span>trabajo</span>
              </div>
              <Contact size={22} className="transition-colors" />
            </Link>

            {/* DUDAS Y OPINIONES */}
            <div className="relative group flex items-center h-full mx-2">
              {/* Disparador (Trigger) */}
              <div className="flex items-center gap-3 cursor-pointer hover:text-[#CE010B] border-b border-black dark:border-white pb-1 dark:text-white transition-colors">
                <div className="flex flex-col leading-[1.1] text-[15px]">
                  <span>Dudas y</span>
                  <span>opiniones</span>
                </div>
                <HelpCircle size={22} className="transition-colors" />
              </div>

              {/* Ventana desplegable (Dropdown) */}
              <div className={`absolute top-[85%] left-0 w-56 border-[1.5px] rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-[100] translate-y-2 group-hover:translate-y-0
                bg-gradient-to-b from-white to-[#C1C1C1] border-black
                dark:from-tbt-red-top dark:to-tbt-red-bottom dark:border-white`}
              >
                <div className="flex flex-col text-center py-1">
                  <Link
                    to="/preguntas"
                    className="px-4 py-4 text-[15px] font-normal transition-colors text-black hover:bg-black/5 dark:text-white dark:hover:bg-white/10"
                  >
                    Preguntas frecuentes
                  </Link>

                  {/* Separador visual */}
                  <div className="h-[1px] bg-black/20 dark:bg-white/20 mx-4"></div>

                  <Link
                    to="/reviews"
                    className="px-4 py-4 text-[15px] font-normal transition-colors text-black hover:bg-black/5 dark:text-white dark:hover:bg-white/10"
                  >
                    Opiniones reales
                  </Link>
                </div>
              </div>
            </div>

            <div className="h-10 w-[1.5px] bg-black/15 dark:bg-white/20 mx-6 transition-colors duration-500"></div>
            {/* ÁREA DE AUTENTICACIÓN Y MODO OSCURO */}
            <div className="flex items-center gap-4">

              {/* Condicional de Sesión: ¿Está el usuario logueado? */}
              {isAuthenticated ? (

                /* SI ESTÁ CONECTADO: Mostramos su nombre (con link a perfil) y el botón de Cerrar Sesión */
                <div className="flex items-center gap-6"> {/* Aumenté un poco el gap para separar mejor */}

                  {/* Envolvemos el bloque de texto en un Link para navegar al perfil */}
                  <Link
                    to="/profile"
                    className="hidden md:flex flex-col text-right group cursor-pointer hover:opacity-70 transition-opacity"
                  >
                    <span className="text-sm font-black uppercase tracking-tight text-black dark:text-white group-hover:text-[#CE010B] transition-colors">
                      {user?.name || 'Usuario'}
                    </span>
                    <span className="text-[9px] uppercase tracking-[0.2em] text-gray-400 dark:text-white/40 font-black">
                      Ver mi Perfil
                    </span>
                  </Link>

                  <div className="h-8 w-[1px] bg-gray-200 dark:bg-white/10 hidden md:block"></div> {/* Un separador visual elegante */}

                  <button
                    onClick={logout}
                    className="flex items-center gap-2 font-regular text-gray-600 hover:text-[#CE010B] text-[16px] border-b border-transparent hover:border-[#CE010B] pb-1 dark:text-white/80 dark:hover:text-white transition-colors duration-500"
                  >
                    <LogOut size={22} className="transition-colors" />
                    <span className="hidden sm:inline">Cerrar sesión</span>
                  </button>
                </div>

              ) : (

                /* SI NO ESTÁ CONECTADO: Mostramos tu botón original de Iniciar Sesión */
                <button
                  onClick={() => openAuthModal('login')}
                  className="flex items-center gap-3 font-regular hover:text-[#CE010B] text-[17px] border-b border-black dark:border-white pb-1 dark:text-white transition-colors duration-500"
                >
                  <UserCircle size={26} className="transition-colors" />
                  <span>Iniciar sesión</span>
                </button>

              )}

              {/* BOTÓN DE TEMA (Modo Oscuro/Claro) */}
              <button
                onClick={() => setIsDark(!isDark)}
                className="p-2 rounded-full transition-colors bg-gray-100 dark:bg-neutral-800 text-gray-800 dark:text-red-400 hover:ring-2 hover:ring-red-500"
              >
                {isDark ? <Sun size={20} /> : <Moon size={20} />}
              </button>

            </div>
          </nav>
        </div>
      </header>
      {/* NUEVO BOTÓN "COTIZAR AHORA" (Alineado con el Navbar) */}
      <div className={`fixed top-2 right-0 h-[84px] hidden lg:flex items-center transition-all duration-500 ${activeTour === 'cotizar' ? 'z-[90]' : 'z-50'}`}>
        {activeTour === 'cotizar' && (
          <div className="absolute inset-0 w-full h-full pointer-events-none z-20">
            <svg className="w-full h-full" viewBox="0 0 224 84" preserveAspectRatio="none">
              <path 
                d="M 33.6,2 L 222,2 L 222,82 L 2,82 Z" 
                fill="none" 
                stroke={isDark ? "#FF3333" : "#CE010B"} 
                strokeWidth="4" 
                className="animate-pulse drop-shadow-[0_0_15px_rgba(206,1,11,0.9)]" 
              />
            </svg>
          </div>
        )}
        {/* Contenedor con borde grueso */}
        <div className="h-full w-56 bg-black dark:bg-white p-[2px]" style={{ clipPath: 'url(#header-shape-button)' }}>

          {/* Contenedor del gradiente vibrante con efecto de luz */}
          <div className="h-full w-full bg-gradient-to-br from-[#FF3333] to-[#D30000] dark:from-neutral-800 dark:to-black shadow-[0_0_25px_rgba(255,0,0,0.6)]" style={{ clipPath: 'url(#header-shape-button)' }}>

            <Link
              to="/cotizar"
              onClick={() => setActiveTour(null)}
              className="h-full w-full flex items-center justify-center gap-3 text-white hover:bg-white/10 transition-all duration-300"
            >
              <div className="flex flex-col items-center leading-tight">
                <span className="text-[15px] font-black uppercase tracking-widest">Cotizar</span>
                <span className="text-[15px] font-black uppercase tracking-widest">Ahora</span>
              </div>
              <div className="flex flex-col items-center">
                <ArrowUp size={16} strokeWidth={4} className="text-white mb-[-6px]" />
                <Banknote size={26} strokeWidth={1.5} className="text-white" />
              </div>
            </Link>

          </div>
        </div>
      </div>
      <main className={`flex-grow pt-[50px] pb-20 relative transition-all duration-300 ${activeTour === 'rastreo' && location.pathname === '/' ? 'z-[90]' : activeTour ? 'z-10' : 'z-0 isolate'}`}>
        <Outlet context={{ activeTour, setActiveTour }} />
      </main>
      <footer className={`relative z-10 w-full py-16 px-6 md:px-14 border-t-[1.5px] transition-all duration-500 
  ${isDark
          ? 'bg-gradient-to-b from-[#590000] to-[#780000] border-white text-white'
          : 'bg-[#CE010B] border-black text-white'}`}
      >

        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-5 gap-10">

          {/* COL 1: LOGO DE LA EMPRESA */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
            <img
              src={isDark ? "/LogoNuevoOscuro.png" : "/LogoNuevoOscuro.png"}
              alt="Logo Grupo TBT"
              className={`h-16 w-auto object-contain transition-all duration-500 `}
            />
            <p className="mt-4 text-lg lg:text-[13px] leading-tight opacity-80 italic">
              Soluciones que <br /> conectan destinos
            </p>
          </div>

          {/* COL 2: ENLACES RÁPIDOS */}
          <div className="flex flex-col gap-4 items-center lg:items-start text-center lg:text-left">
            <h4 className="font-bold text-2xl lg:text-[18px] uppercase tracking-tighter border-b border-black/20 dark:border-white/20 pb-2 transition-colors w-full" style={{ fontFamily: "'Secular One', sans-serif" }}>
              Enlaces Rápidos
            </h4>
            <nav className="flex flex-col gap-2 text-lg lg:text-[15px] font-medium">
              <a href="/cotizar" className="hover:text-black dark:hover:text-white/60 transition-colors">Cotizar Ahora</a>
              <a href="/rastreo" className="hover:text-black dark:hover:text-white/60 transition-colors">Rastrear Envío</a>
              <a href="/trabajos" className="hover:text-black dark:hover:text-white/60 transition-colors">Bolsa de Trabajo</a>
              <Link to="/nosotros" className="hover:text-black dark:hover:text-white/60 transition-colors">Nosotros</Link>
            </nav>
          </div>

          {/* COL 3: LEGALES */}
          <div className="flex flex-col gap-4 items-center lg:items-start text-center lg:text-left">
            <h4 className="font-bold text-2xl lg:text-[18px] uppercase tracking-tighter border-b border-black/20 dark:border-white/20 pb-2 transition-colors w-full" style={{ fontFamily: "'Secular One', sans-serif" }}>
              Legales
            </h4>
            <nav className="flex flex-col gap-2 text-lg lg:text-[15px] font-medium">
              <a href="/terminos" className="hover:text-black dark:hover:text-white/60 transition-colors">Términos y Condiciones</a>
              <a href="/privacidad" className="hover:text-black dark:hover:text-white/60 transition-colors">Aviso de Privacidad</a>
              <a href="/preguntas" className="hover:text-black dark:hover:text-white/60 transition-colors">Preguntas Frecuentes</a>
            </nav>
          </div>

          {/* COL 4: CONTÁCTANOS */}
          <div className="flex flex-col gap-4 items-center lg:items-start text-center lg:text-left w-full">
            <h4
              className="font-bold text-2xl lg:text-[18px] uppercase tracking-tighter border-b border-white/20 pb-2 transition-colors flex items-center justify-center lg:justify-start gap-2 w-full text-white"
              style={{ fontFamily: "'Secular One', sans-serif" }}
            >
              Contáctanos
            </h4>

            {/* Selector de Sucursal */}
            {branches && branches.length > 0 && (
              <div className="w-full max-w-[240px] mt-1 mb-1">
                <select
                  value={branchInfo.id || ''}
                  onChange={(e) => {
                    const selected = branches.find(b => b.id === parseInt(e.target.value));
                    if (selected) {
                      setBranchInfo(selected);
                    }
                  }}
                  className="w-full bg-white/10 dark:bg-black/20 text-white border border-white/20 rounded-lg px-3 py-2 text-base lg:text-xs font-semibold focus:outline-none focus:ring-2 focus:ring-white cursor-pointer uppercase tracking-wider"
                >
                  {branches
                    .filter(b => b.name && (
                      (b.phone && b.phone.trim() !== '') || 
                      (b.direccion && b.direccion.trim() !== '') || 
                      (b.email_contacto && b.email_contacto.trim() !== '')
                    ))
                    .map(b => (
                      <option key={b.id} value={b.id} className="text-black">
                        {b.city || b.name}
                      </option>
                    ))
                  }
                </select>
              </div>
            )}

            <div className="flex flex-col gap-2 text-lg lg:text-[15px] font-medium w-full text-white text-center lg:text-left items-center lg:items-start">
              <p>
                <span className="font-black mr-1 text-white">WhatsApp:</span>
                {branchInfo.phone}
              </p>
              <p className="break-all">
                <span className="font-black mr-1 text-white">Email:</span>
                {branchInfo.email_contacto || 'paqueteriamasenvios@gmail.com'}
              </p>
              <p className="text-lg lg:text-[13px] opacity-90 mt-1 leading-relaxed">
                {branchInfo.direccion}
              </p>
            </div>
          </div>

          {/* COL 5: SÍGUENOS */}
          <div className="flex flex-col gap-4 items-center lg:items-start text-center lg:text-left">
            <h4 className="font-bold text-2xl lg:text-[18px] uppercase tracking-tighter border-b border-black/20 dark:border-white/20 pb-2 transition-colors w-full" style={{ fontFamily: "'Secular One', sans-serif" }}>
              Síguenos
            </h4>
            <div className="flex flex-col lg:flex-row gap-4 justify-center lg:justify-start items-center">
              {/* TIKTOK */}
              <a
                href="https://www.tiktok.com/@paqueteria.mas.en"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white dark:bg-black border-[1.5px] border-transparent dark:border-white rounded-full hover:scale-110 transition-all duration-500 shadow-lg w-14 h-14 lg:w-12 lg:h-12 flex items-center justify-center overflow-hidden p-2.5 md:p-3"
              >
                <img src={isDark ? "/tiktok_oscuro.png" : "/tiktok.png"} alt="TikTok" className="w-full h-full object-contain" />
              </a>

              {/* INSTAGRAM */}
              <a
                href="https://www.instagram.com/pmasenvios"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white dark:bg-black border-[1.5px] border-transparent dark:border-white rounded-full hover:scale-110 transition-all duration-500 shadow-lg w-14 h-14 lg:w-12 lg:h-12 flex items-center justify-center overflow-hidden p-2.5 md:p-3"
              >
                <img src={isDark ? "/instagram_oscuro.png" : "/instagram.png"} alt="Instagram" className="w-full h-full object-contain" />
              </a>

              {/* FACEBOOK */}
              <a
                href="https://www.facebook.com/profile.php?id=61588121619199"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white dark:bg-black border-[1.5px] border-transparent dark:border-white rounded-full hover:scale-110 transition-all duration-500 shadow-lg w-14 h-14 lg:w-12 lg:h-12 flex items-center justify-center overflow-hidden p-2.5 md:p-3"
              >
                <img src={isDark ? "/facebook_oscuro.png" : "/facebook.png"} alt="Facebook" className="w-full h-full object-contain" />
              </a>
            </div>
          </div>
        </div>
        {/* LÍNEA FINAL DE DERECHOS */}
        <div className="mt-16 pt-8 border-t border-black/10 dark:border-white/10 text-center text-base lg:text-[13px] opacity-70 transition-colors duration-500">
          <p>© 2026 Paquetería Más Envíos. Todos los derechos reservados.</p>
        </div>
      </footer>
      {/* VENTANA DE CHAT COMPACTA */}
      <div
        style={{ bottom: isAtFooter ? 'calc(100vh - 250px)' : undefined }}
        className={`fixed z-[60] w-[525px] max-w-[92vw] lg:w-[300px] rounded-[2.5rem] border-[1.5px] border-black dark:border-white shadow-2xl transition-all duration-500 origin-bottom-left lg:origin-bottom-right overflow-hidden
          left-8 lg:left-auto lg:right-8
          ${isChatOpen && !isKeyboardOpen ? 'scale-100 opacity-100 visible' : 'scale-0 opacity-0 invisible pointer-events-none'}
          ${isAtFooter ? 'absolute' : 'fixed bottom-56 lg:bottom-28'}
          ${!isDark ? 'bg-gradient-to-b from-[#F1F1F1] to-[#C1C1C1]' : 'bg-neutral-900'}`}
      >
        {/* Header con degradados personalizados */}
        <div className={`p-7 lg:p-5 flex items-center justify-between
          ${!isDark
            ? 'bg-[#CE010B]'
            : 'bg-gradient-to-b from-[#780000] to-[#590000]'}`}
        >
          <div className="flex items-center gap-3">
            <MessageSquareText className="w-6 h-6 lg:w-4 lg:h-4 text-white" />
            <p className="text-white text-2xl lg:text-[14px] font-normal normal-case tracking-tight">Asistente MásBot</p>
          </div>
          <button onClick={() => { setIsChatOpen(false); setChatStep('inicio'); }} className="text-white/80 hover:text-white flex items-center justify-center">
            <X className="w-7 h-7 lg:w-[18px] lg:h-[18px] text-white" />
          </button>
        </div>

        {/* Cuerpo del Chat */}
        <div className="p-8 lg:p-6 space-y-4 max-h-[380px] lg:max-h-[350px] overflow-y-auto font-light">
          <div className="flex flex-col items-start gap-1">
            <div className={`border border-black/10 p-6 lg:p-4 rounded-3xl rounded-tl-none shadow-sm w-full ${chatStep === 'inicio' ? 'bg-black' : 'bg-white dark:bg-neutral-800'}`}>
              <p className={`text-xl lg:text-[13px] font-normal leading-relaxed ${chatStep === 'inicio' ? 'text-white' : 'dark:text-white'}`}>
                {chatStep === 'inicio' && "¡Hola, soy MásBot! ¿En qué puedo ayudarte hoy?"}
                {chatStep === 'cotizar' && "Puedes realizar tu cotización al instante en nuestro Cotizador en línea, o hablar directamente con un asesor por WhatsApp."}
                {chatStep === 'rastreo' && "Para rastrear tu envío, dirígete a nuestra sección de rastreo en línea e ingresa tu número de guía de 10 dígitos."}
                {chatStep === 'sucursales' && "Contamos con sucursales físicas en Toluca y Pachuca listas para recibir y despachar tus paquetes."}
                {chatStep === 'atencion' && "Por favor, selecciona la sucursal con la que deseas comunicarte por WhatsApp:"}
              </p>
            </div>
          </div>

          {/* Opciones Predeterminadas */}
          <div className="flex flex-col gap-2 pt-2">
            {chatStep === 'inicio' ? (
              <>
                <button onClick={() => { setIsChatOpen(false); setActiveTour('cotizar'); }} className="w-full p-6 lg:p-3 text-[24px] lg:text-[13px] font-normal normal-case bg-white dark:bg-gradient-to-b dark:from-[#780000] dark:to-[#590000] dark:text-white dark:border-white/10 border border-black/10 rounded-xl hover:bg-[#CE010B] hover:text-white hover:border-[#CE010B] transition-colors duration-200 cursor-pointer flex items-center justify-between gap-3">
                  <span>Deseo cotizar un envío</span>
                  <Banknote className="w-8 h-8 lg:w-4 lg:h-4 shrink-0" />
                </button>
                <button onClick={() => { setIsChatOpen(false); setActiveTour('rastreo'); }} className="w-full p-6 lg:p-3 text-[24px] lg:text-[13px] font-normal normal-case bg-white dark:bg-gradient-to-b dark:from-[#780000] dark:to-[#590000] dark:text-white dark:border-white/10 border border-black/10 rounded-xl hover:bg-[#CE010B] hover:text-white hover:border-[#CE010B] transition-colors duration-200 cursor-pointer flex items-center justify-between gap-3">
                  <span>Deseo rastrear mi Envío</span>
                  <Crosshair className="w-8 h-8 lg:w-4 lg:h-4 shrink-0" />
                </button>
                <button onClick={handleStartSucursalesTour} className="w-full p-6 lg:p-3 text-[24px] lg:text-[13px] font-normal normal-case bg-white dark:bg-gradient-to-b dark:from-[#780000] dark:to-[#590000] dark:text-white dark:border-white/10 border border-black/10 rounded-xl hover:bg-[#CE010B] hover:text-white hover:border-[#CE010B] transition-colors duration-200 cursor-pointer flex items-center justify-between gap-3">
                  <span>Dónde estan sus sucursales</span>
                  <MapPin className="w-8 h-8 lg:w-4 lg:h-4 shrink-0" />
                </button>
                <button onClick={() => setChatStep('atencion')} className="w-full p-6 lg:p-3 text-[24px] lg:text-[13px] font-bold normal-case bg-[#25D366] text-white border border-transparent rounded-xl hover:bg-green-600 transition-colors duration-200 cursor-pointer flex items-center justify-between gap-3">
                  <span>Atención personalizada</span>
                  <div className="w-8 h-8 lg:w-5 lg:h-5 bg-white rounded-full flex items-center justify-center shrink-0 p-1">
                    <img src="/whatsapp.png" alt="WhatsApp" className="w-full h-full object-contain" />
                  </div>
                </button>
              </>
            ) : (
              <div className="flex flex-col gap-2">
                {chatStep === 'cotizar' && (
                  <>
                    <a href="/cotizar" onClick={() => setIsChatOpen(false)} className="w-full p-6 lg:p-3 text-xl lg:text-[13px] font-normal normal-case bg-[#CE010B] text-white rounded-xl text-center block hover:bg-[#a80008] transition-colors">
                      Ir al Cotizador
                    </a>
                    <a href={getWhatsAppLink("Hola, deseo cotizar un envío. ¿Me podrían asesorar?")} target="_blank" rel="noopener noreferrer" className="w-full p-6 lg:p-3 text-xl lg:text-[13px] font-normal normal-case bg-[#25D366] text-white rounded-xl text-center block hover:bg-green-600 transition-colors">
                      Cotizar por WhatsApp
                    </a>
                  </>
                )}
                {chatStep === 'rastreo' && (
                  <a href="/rastreo" onClick={() => setIsChatOpen(false)} className="w-full p-6 lg:p-3 text-xl lg:text-[13px] font-normal normal-case bg-[#CE010B] text-white rounded-xl text-center block hover:bg-[#a80008] transition-colors">
                    Ir a Rastrear Envío
                  </a>
                )}
                {chatStep === 'atencion' && (
                  <div className="flex flex-col gap-2 max-h-[220px] overflow-y-auto pr-1">
                    {branches
                      .filter(b => b.phone && b.phone.trim() !== '')
                      .map(branch => (
                        <a
                          key={branch.id}
                          href={`https://wa.me/52${branch.phone.replace(/\D/g, '')}?text=${encodeURIComponent("Hola, me gustaría recibir atención personalizada.")}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => setIsChatOpen(false)}
                          className="w-full p-5 lg:p-3 text-[20px] lg:text-[13px] font-bold bg-white dark:bg-neutral-800 border border-black/10 dark:border-white/10 rounded-xl hover:bg-neutral-100 dark:hover:bg-neutral-700 transition-colors flex items-center justify-between no-underline"
                        >
                          <span className="text-black dark:text-white uppercase tracking-tight">{branch.name}</span>
                          <div className="w-7 h-7 bg-[#25D366]/10 flex items-center justify-center rounded-full shrink-0">
                            <img src="/whatsapp.png" alt="WhatsApp" className="w-4 h-4 object-contain" />
                          </div>
                        </a>
                      ))
                    }
                  </div>
                )}
                <button onClick={() => setChatStep('inicio')} className="text-lg lg:text-[12px] font-normal normal-case text-[#CE010B] hover:underline mt-2 text-left border-none bg-transparent cursor-pointer">
                  ← Volver al inicio
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* BOTÓN DISPARADOR (Trigger) */}
      <button
        onClick={() => setIsChatOpen(!isChatOpen)}
        className={`fixed z-[60] group flex items-center justify-center transition-all duration-300
          left-8 lg:left-auto lg:right-8
          ${isAtFooter ? 'bottom-[420px]' : 'bottom-16 lg:bottom-8'}
          ${isKeyboardOpen ? 'scale-0 opacity-0 pointer-events-none' : 'scale-100 opacity-100'}`}
      >
        <span className={`absolute transition-all duration-300 pointer-events-none shadow-xl border px-4 py-2 text-[10px] font-black uppercase tracking-widest rounded-xl
          left-full ml-4 lg:left-auto lg:right-full lg:mr-4 lg:ml-0
          ${isChatOpen ? 'opacity-0' : 'opacity-0 group-hover:opacity-100'} 
          ${!isDark
            ? 'bg-gradient-to-b from-[#F1F1F1] to-[#C1C1C1] text-black border-black/10'
            : 'bg-black text-white border-white/20'}`}
        >
          ¿Ayuda?
        </span>

        <div className={`w-36 h-36 lg:w-20 lg:h-20 rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 border-[2px] border-white/20
          ${isChatOpen ? 'rotate-90 scale-90' : 'hover:scale-110 active:scale-95'}
          ${!isDark
            ? 'bg-[#CE010B]'
            : 'bg-gradient-to-b from-[#780000] to-[#590000]'}`}
        >
          {isChatOpen ? <X size={66} className="lg:w-[35px] lg:h-[35px] text-white" /> : <MessageSquareText size={66} className="lg:w-[35px] lg:h-[35px] text-white animate-pulse" />}
        </div>
      </button>

      {/* MENÚ MÓVIL ENTRADA LATERAL */}
      <AnimatePresence>
        {isSidebarOpen && (
          <>
            {/* Backdrop con Blur */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsSidebarOpen(false)}
              className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100]"
            />

            {/* Panel del Drawer */}
            <motion.div
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ type: 'spring', damping: 25, stiffness: 200 }}
              className={`fixed right-0 top-0 bottom-0 w-[350px] max-w-[92vw] z-[101] shadow-2xl flex flex-col justify-between border-l border-black/10 dark:border-white/20 transition-all duration-300
                ${!isDark ? 'bg-gradient-to-b from-white to-[#E5E5E5]' : 'bg-gradient-to-b from-[#590000] to-[#780000] text-white'}`}
            >
              {/* Header del Menu */}
              <div className="p-6 border-b border-black/10 dark:border-white/10 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <img
                    src={isDark ? "/LogoNuevoOscuro.png" : "/LogoNuevoClaro.png"}
                    alt="Logo"
                    className="h-12 w-auto object-contain"
                  />
                </div>
                <div className="flex items-center gap-3">
                  {/* Botón de tema claro/oscuro */}
                  <button
                    onClick={() => setIsDark(!isDark)}
                    className="p-3 rounded-full bg-black/5 dark:bg-white/5 text-black dark:text-white"
                  >
                    {isDark ? <Sun size={24} /> : <Moon size={24} />}
                  </button>
                  {/* Botón de cerrar */}
                  <button
                    onClick={() => setIsSidebarOpen(false)}
                    className="p-3 rounded-full hover:bg-black/5 dark:hover:bg-white/5 transition-colors"
                  >
                    <X size={32} />
                  </button>
                </div>
              </div>

              {/* Lista de enlaces */}
              <div className="flex-1 overflow-y-auto px-6 py-6 space-y-8">
                {/* Sección de Usuario / Sesión (AHORA EN LA PARTE SUPERIOR) */}
                <div className="pb-6 border-b border-black/10 dark:border-white/20">
                  {isAuthenticated ? (
                    <div className="space-y-4">
                      <div className="flex items-center gap-4">
                        <div className="w-16 h-16 rounded-full bg-[#CE010B] text-white flex items-center justify-center font-bold text-3xl border border-white/20">
                          {user?.name?.charAt(0).toUpperCase() || 'U'}
                        </div>
                        <div className="flex flex-col">
                          <span className="font-black text-xl uppercase tracking-tight leading-tight">{user?.name || 'Usuario'}</span>
                          <span className="text-xs text-gray-400 dark:text-white/40 uppercase tracking-widest font-black">{user?.role || 'Cliente'}</span>
                        </div>
                      </div>
                      <div className="flex gap-3">
                        <Link
                          to="/profile"
                          onClick={() => setIsSidebarOpen(false)}
                          className="flex-1 py-5 text-center rounded-xl bg-black/10 dark:bg-white/10 hover:bg-black/20 dark:hover:bg-white/20 transition-colors font-black text-base uppercase tracking-wider animate-pulse"
                        >
                          Ver Perfil
                        </Link>
                        <button
                          onClick={() => { logout(); setIsSidebarOpen(false); }}
                          className="flex items-center justify-center p-5 rounded-xl bg-red-500/10 text-[#CE010B] dark:text-red-400 hover:bg-red-500/20 transition-colors"
                          title="Cerrar sesión"
                        >
                          <LogOut size={30} />
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button
                      onClick={() => { openAuthModal('login'); setIsSidebarOpen(false); }}
                      className="w-full flex items-center justify-center gap-3 py-6 rounded-2xl border-[1.5px] border-black dark:border-white font-black text-lg uppercase tracking-widest bg-white dark:bg-neutral-900 shadow-md hover:scale-105 active:scale-95 transition-all text-black dark:text-white"
                    >
                      <UserCircle size={32} />
                      <span>Iniciar Sesión</span>
                    </button>
                  )}
                </div>


                <div className="space-y-4">
                  <p className="text-sm font-black uppercase tracking-widest text-gray-400 dark:text-gray-500 border-b border-black/10 dark:border-white/20 pb-2">Servicios</p>
                  <nav className="flex flex-col gap-2">
                    <Link
                      to="/rastreo"
                      onClick={closeTour}
                      className={`flex items-center gap-6 py-6 px-4 rounded-xl hover:bg-black/5 dark:hover:bg-white/5 transition-all font-black text-xl uppercase tracking-tight
                        ${activeTour === 'rastreo' && location.pathname !== '/'
                          ? 'relative z-[115] scale-105 border-[3px] border-[#CE010B] dark:border-[#FF3333] ring-4 ring-[#CE010B] dark:ring-[#FF3333] shadow-[0_0_25px_rgba(206,1,11,0.6)] bg-white dark:bg-neutral-900 animate-pulse'
                          : ''
                        }`}
                    >
                      <Crosshair size={30} className="text-[#CE010B] dark:text-red-500" />
                      <span>Rastrear Envío</span>
                    </Link>

                    <Link
                      to="/trabajos"
                      onClick={() => setIsSidebarOpen(false)}
                      className="flex items-center gap-6 py-6 px-4 rounded-xl hover:bg-black/5 dark:hover:bg-white/5 transition-colors font-black text-xl uppercase tracking-tight"
                    >
                      <Contact size={30} className="text-[#CE010B] dark:text-red-500" />
                      <span>Bolsa de Trabajo</span>
                    </Link>
                  </nav>
                </div>

                <div className="space-y-4">
                  <p className="text-sm font-black uppercase tracking-widest text-gray-400 dark:text-gray-500 border-b border-black/10 dark:border-white/20 pb-2">Soluciones para Negocio</p>
                  <nav className="flex flex-col gap-2">
                    <HashLink
                      scroll={(el) => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                      to="/#faq"
                      onClick={() => setIsSidebarOpen(false)}
                      className="flex items-center gap-6 py-6 px-4 rounded-xl hover:bg-black/5 dark:hover:bg-white/5 transition-colors font-black text-xl uppercase tracking-tight"
                    >
                      <Rocket size={30} className="text-[#CE010B] dark:text-red-500" />
                      <span>Empieza tu negocio</span>
                    </HashLink>

                    <HashLink
                      scroll={(el) => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                      to="/#empresa"
                      onClick={() => setIsSidebarOpen(false)}
                      className="flex items-center gap-6 py-6 px-4 rounded-xl hover:bg-black/5 dark:hover:bg-white/5 transition-colors font-black text-xl uppercase tracking-tight"
                    >
                      <TrendingUp size={30} className="text-[#CE010B] dark:text-red-500" />
                      <span>Mejora tu empresa</span>
                    </HashLink>
                  </nav>
                </div>

                <div className="space-y-4">
                  <p className="text-sm font-black uppercase tracking-widest text-gray-400 dark:text-gray-500 border-b border-black/10 dark:border-white/20 pb-2">Soporte y Opiniones</p>
                  <nav className="flex flex-col gap-2">
                    <Link
                      to="/preguntas"
                      onClick={() => setIsSidebarOpen(false)}
                      className="flex items-center gap-6 py-6 px-4 rounded-xl hover:bg-black/5 dark:hover:bg-white/5 transition-colors font-black text-xl uppercase tracking-tight"
                    >
                      <HelpCircle size={30} className="text-[#CE010B] dark:text-red-500" />
                      <span>Preguntas Frecuentes</span>
                    </Link>

                    <Link
                      to="/reviews"
                      onClick={() => setIsSidebarOpen(false)}
                      className="flex items-center gap-6 py-6 px-4 rounded-xl hover:bg-black/5 dark:hover:bg-white/5 transition-colors font-black text-xl uppercase tracking-tight"
                    >
                      <MessageSquareText size={30} className="text-[#CE010B] dark:text-red-500" />
                      <span>Opiniones Reales</span>
                    </Link>
                  </nav>
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {activeTour === 'cotizar' && (
        <>
          {/* Overlay */}
          <div 
            className="fixed inset-0 bg-black/75 backdrop-blur-sm z-[80] pointer-events-auto"
            onClick={() => setActiveTour(null)}
          />
          
          {/* Floating Card */}
          <div className="fixed z-[95] bg-white dark:bg-[#1A1A1A] border-[1.5px] border-[#CE010B]/30 dark:border-white/10 rounded-[2.5rem] shadow-2xl p-8 max-w-[92vw] overflow-hidden transition-all duration-500 animate-in zoom-in-95 top-[40%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[420px] lg:top-28 lg:right-64 lg:left-auto lg:translate-x-0 lg:translate-y-0 lg:w-[380px]"
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2">
                <Rocket className="w-7 h-7 lg:w-5 lg:h-5 text-[#CE010B] dark:text-red-500 animate-bounce" />
                <span className="text-[16px] lg:text-[11px] font-black uppercase tracking-wider text-[#CE010B] dark:text-red-500">GUÍA DEL SISTEMA (1/1)</span>
              </div>
              <button 
                onClick={() => setActiveTour(null)} 
                className="text-gray-400 hover:text-black dark:hover:text-white cursor-pointer"
              >
                <X size={24} lg={20} />
              </button>
            </div>

            {/* Content */}
            <div className="space-y-4">
              <h4 className="text-3xl lg:text-xl font-bold text-black dark:text-white leading-tight flex items-center gap-2">
                👋 Cotizar Envío
              </h4>
              <p className="text-[19px] lg:text-[13px] text-gray-600 dark:text-gray-300 leading-relaxed font-light">
                Puedes realizar tu cotización al instante en nuestro Cotizador en línea, o hablar directamente con un asesor por WhatsApp.
              </p>

              {/* Action Buttons */}
              <div className="flex flex-col gap-2 pt-2">
                <div className="relative">
                  <button
                    onClick={() => setIsTourWADropdownOpen(prev => !prev)}
                    onBlur={() => setTimeout(() => setIsTourWADropdownOpen(false), 150)}
                    className="w-full p-5 text-[19px] lg:p-4 lg:text-[13px] font-bold uppercase tracking-widest bg-[#25D366] text-white rounded-2xl text-center flex items-center justify-center gap-2 hover:bg-green-600 transition-colors duration-200 cursor-pointer"
                  >
                    <span>Cotizar por WhatsApp</span>
                    <div className="w-6 h-6 lg:w-5 lg:h-5 overflow-hidden shrink-0">
                      <img src="/whatsapp.png" alt="WhatsApp" className="w-full h-full object-contain" />
                    </div>
                  </button>

                  {/* Dropdown de sucursales */}
                  {isTourWADropdownOpen && (
                    <div className="absolute top-full mt-2 left-0 right-0 z-50 bg-white dark:bg-neutral-900 border border-black/10 dark:border-white/20 rounded-2xl shadow-xl overflow-hidden max-h-[200px] overflow-y-auto">
                      {branches
                        .filter(b => b.phone && b.phone.trim() !== '')
                        .map(branch => (
                          <a
                            key={branch.id}
                            href={`https://wa.me/52${branch.phone.replace(/\D/g, '')}?text=${encodeURIComponent("Hola, deseo cotizar un envío. ¿Me podrían asesorar?")}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => setActiveTour(null)}
                            className="flex items-center gap-3 px-5 py-3 hover:bg-[#CE010B] hover:text-white transition-colors group no-underline text-left"
                          >
                            <div className="bg-[#25D366] p-1 rounded-full flex items-center justify-center w-6 h-6 overflow-hidden shrink-0">
                              <img src="/whatsapp.png" alt="WhatsApp" className="w-full h-full object-contain" />
                            </div>
                            <span className="text-black dark:text-white group-hover:text-white text-[20px] lg:text-[14px] font-semibold">{branch.name}</span>
                          </a>
                        ))
                      }
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="flex justify-between items-center mt-6 pt-4 border-t border-black/5 dark:border-white/5">
              <button 
                onClick={() => setActiveTour(null)} 
                className="text-base lg:text-xs font-bold uppercase text-gray-400 hover:text-black dark:hover:text-white cursor-pointer"
              >
                Saltar
              </button>
              <button 
                onClick={() => setActiveTour(null)} 
                className="bg-black hover:bg-neutral-800 dark:bg-white dark:hover:bg-neutral-200 dark:text-black text-white px-6 py-3.5 lg:px-5 lg:py-2.5 rounded-xl text-base lg:text-xs font-bold uppercase tracking-widest shadow-md transition-all flex items-center gap-2 cursor-pointer"
              >
                Entendido
              </button>
            </div>
          </div>
        </>
      )}

      {activeTour === 'rastreo' && (
        <>
          {/* Overlay (only rendered if sidebar is closed and not on landing page, otherwise local backdrop/sidebar handles it) */}
          {!isSidebarOpen && location.pathname !== '/' && (
            <div 
              className="fixed inset-0 bg-black/75 backdrop-blur-sm z-[80] pointer-events-auto"
              onClick={closeTour}
            />
          )}
          
          {/* Floating Card */}
          <div className={`fixed bg-white dark:bg-[#1A1A1A] border-[1.5px] border-[#CE010B]/30 dark:border-white/10 rounded-[2.5rem] shadow-2xl p-8 max-w-[92vw] overflow-hidden transition-all duration-500 animate-in zoom-in-95
            ${isSidebarOpen 
              ? 'top-[52%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[420px] z-[110]'
              : location.pathname === '/'
                ? 'top-[68%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[420px] lg:top-[48%] lg:left-1/2 lg:-translate-x-1/2 lg:w-[420px] z-[95]'
                : 'top-[48%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[420px] lg:top-28 lg:left-48 lg:translate-x-0 lg:translate-y-0 lg:w-[380px] z-[95]'
            }`}
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2">
                <Rocket className="w-7 h-7 lg:w-5 lg:h-5 text-[#CE010B] dark:text-red-500 animate-bounce" />
                <span className="text-[16px] lg:text-[11px] font-black uppercase tracking-wider text-[#CE010B] dark:text-red-500">GUÍA DEL SISTEMA (1/1)</span>
              </div>
              <button 
                onClick={closeTour} 
                className="text-gray-400 hover:text-black dark:hover:text-white cursor-pointer"
              >
                <X size={24} lg={20} />
              </button>
            </div>

            {/* Content */}
            <div className="space-y-4">
              <h4 className="text-3xl lg:text-xl font-bold text-black dark:text-white leading-tight flex items-center gap-2">
                🔍 Rastrear Envío
              </h4>
              <p className="text-[22px] lg:text-[13px] text-gray-600 dark:text-gray-300 leading-relaxed font-light">
                Para rastrear tu envío, dirígete a nuestra sección de rastreo en línea e ingresa tu número de guía de 10 dígitos.
              </p>
            </div>

            {/* Footer */}
            <div className="flex justify-between items-center mt-6 pt-4 border-t border-black/5 dark:border-white/5">
              <button 
                onClick={closeTour} 
                className="text-base lg:text-xs font-bold uppercase text-gray-400 hover:text-black dark:hover:text-white cursor-pointer"
              >
                Saltar
              </button>
              <button 
                onClick={closeTour} 
                className="bg-black hover:bg-neutral-800 dark:bg-white dark:hover:bg-neutral-200 dark:text-black text-white px-6 py-3.5 lg:px-5 lg:py-2.5 rounded-xl text-base lg:text-xs font-bold uppercase tracking-widest shadow-md transition-all flex items-center gap-2 cursor-pointer"
              >
                Entendido
              </button>
            </div>
          </div>
        </>
      )}

      {activeTour === 'sucursales' && location.pathname === '/' && (
        <>
          
          {/* Floating Card */}
          <div className="fixed bg-white dark:bg-[#1A1A1A] border-[1.5px] border-[#CE010B]/30 dark:border-white/10 rounded-[2.5rem] shadow-2xl p-8 max-w-[92vw] overflow-hidden transition-all duration-500 animate-in zoom-in-95 top-[40%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[420px] lg:top-[68%] lg:left-1/2 lg:-translate-x-1/2 lg:w-[450px] z-[95]"
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2">
                <Rocket className="w-7 h-7 lg:w-5 lg:h-5 text-[#CE010B] dark:text-red-500 animate-bounce" />
                <span className="text-[16px] lg:text-[11px] font-black uppercase tracking-wider text-[#CE010B] dark:text-red-500">GUÍA DEL SISTEMA (1/1)</span>
              </div>
              <button 
                onClick={closeTour} 
                className="text-gray-400 hover:text-black dark:hover:text-white cursor-pointer"
              >
                <X size={24} lg={20} />
              </button>
            </div>

            {/* Content */}
            <div className="space-y-4">
              <h4 className="text-3xl lg:text-xl font-bold text-black dark:text-white leading-tight flex items-center gap-2">
                📍 Nuestras Sucursales
              </h4>
              <p className="text-[19px] lg:text-[13px] text-gray-600 dark:text-gray-300 leading-relaxed font-light">
                Contamos con sucursales físicas en Toluca y Pachuca listas para recibir y despachar tus paquetes.
              </p>
            </div>

            {/* Footer */}
            <div className="flex justify-between items-center mt-6 pt-4 border-t border-black/5 dark:border-white/5">
              <button 
                onClick={closeTour} 
                className="text-base lg:text-xs font-bold uppercase text-gray-400 hover:text-black dark:hover:text-white cursor-pointer"
              >
                Saltar
              </button>
              <button 
                onClick={closeTour} 
                className="bg-black hover:bg-neutral-800 dark:bg-white dark:hover:bg-neutral-200 dark:text-black text-white px-6 py-3.5 lg:px-5 lg:py-2.5 rounded-xl text-base lg:text-xs font-bold uppercase tracking-widest shadow-md transition-all flex items-center gap-2 cursor-pointer"
              >
                Entendido
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}